/**
 * Custom Search Page Functionality
 */

(function() {
  'use strict';

  const searchInput = document.getElementById('search-input');
  const typeFilter = document.getElementById('type-filter');
  const topicFilter = document.getElementById('topic-filter');
  const topicFilterGroup = document.getElementById('topic-filter-group');
  const clearFiltersBtn = document.getElementById('clear-search-filters');
  const resultsGrid = document.getElementById('search-results-grid');
  const paginationContainer = document.getElementById('search-pagination');

  if (!searchInput || !resultsGrid) return;

  let currentPage = 1;
  let currentQuery = searchInput.value || '';
  let currentType = '';
  let currentTopic = '';
  const perPage = 12;

  // Load state from URL parameters
  loadStateFromURL();

  // Initialize
  if (currentQuery || currentType || currentTopic) {
    performSearch();
  }
  
  // Show/hide topic filter based on content type
  updateTopicFilterVisibility();

  // Event listeners
  searchInput.addEventListener('input', debounce(function() {
    currentQuery = this.value.trim();
    currentPage = 1;
    performSearch();
  }, 500));

  typeFilter.addEventListener('change', function() {
    currentType = this.value;
    currentPage = 1;
    updateTopicFilterVisibility();
    performSearch();
  });

  topicFilter.addEventListener('change', function() {
    currentTopic = this.value;
    currentPage = 1;
    performSearch();
  });

  clearFiltersBtn.addEventListener('click', function() {
    searchInput.value = '';
    typeFilter.value = '';
    topicFilter.value = '';
    currentQuery = '';
    currentType = '';
    currentTopic = '';
    currentPage = 1;
    resultsGrid.innerHTML = '';
    paginationContainer.innerHTML = '';
    updateTopicFilterVisibility();
    updateURL();
  });

  function updateTopicFilterVisibility() {
    if (currentType === 'user' || currentType === '') {
      topicFilterGroup.style.display = 'none';
      currentTopic = '';
      topicFilter.value = '';
    } else {
      topicFilterGroup.style.display = 'flex';
    }
  }

  function loadStateFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('search')) {
      currentQuery = urlParams.get('search');
      searchInput.value = currentQuery;
    }
    
    if (urlParams.has('type')) {
      currentType = urlParams.get('type');
      typeFilter.value = currentType;
    }
    
    if (urlParams.has('topic')) {
      currentTopic = urlParams.get('topic');
      topicFilter.value = currentTopic;
    }
    
    if (urlParams.has('page')) {
      currentPage = parseInt(urlParams.get('page'));
    }
  }

  function updateURL() {
    const params = new URLSearchParams();
    
    if (currentQuery) {
      params.set('search', currentQuery);
    }
    
    if (currentType) {
      params.set('type', currentType);
    }
    
    if (currentTopic) {
      params.set('topic', currentTopic);
    }
    
    if (currentPage > 1) {
      params.set('page', currentPage);
    }
    
    const newURL = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.pushState({}, '', newURL);
  }

  function performSearch() {
    if (!currentQuery && !currentType && !currentTopic) {
      resultsGrid.innerHTML = '<div class="no-results"><h3>Enter a search term or select a filter</h3><p>Start typing or select a content type to search</p></div>';
      paginationContainer.innerHTML = '';
      updateURL();
      return;
    }

    // Update URL with current filters
    updateURL();

    // Show loading spinner
    resultsGrid.innerHTML = '<div class="events-loading-spinner"><div class="spinner"></div><p>Loading results...</p></div>';

    let url = window.location.origin + '/wp-admin/admin-ajax.php?action=custom_search&per_page=' + perPage + '&page=' + currentPage;
    
    if (currentQuery) {
      url += '&search=' + encodeURIComponent(currentQuery);
    }
    
    if (currentType) {
      url += '&type=' + currentType;
    }

    if (currentTopic) {
      url += '&topic=' + currentTopic;
    }

    fetch(url)
      .then(response => response.json())
      .then(data => {
        displayResults(data.results);
        displayPagination(data.total_pages);
      })
      .catch(error => {
        console.error('Search error:', error);
        resultsGrid.innerHTML = '<div class="no-results"><h3>Error</h3><p>There was an error performing the search</p></div>';
      });
  }

  function displayResults(results) {
    if (!results || results.length === 0) {
      resultsGrid.innerHTML = '<div class="no-results"><h3>No results found</h3><p>Try adjusting your search terms or filters</p></div>';
      return;
    }

    let html = '';
    results.forEach(result => {
      html += result.html;
    });

    resultsGrid.innerHTML = html;
  }

  function displayPagination(totalPages) {
    if (totalPages <= 1) {
      paginationContainer.innerHTML = '';
      return;
    }

    let html = '<div class="c-pagination">';
    
    // Previous button
    if (currentPage > 1) {
      html += `<button class="c-pagination__nav c-pagination__nav--prev" onclick="goToPage(${currentPage - 1})">Previous</button>`;
    }
    
    // Page numbers
    html += '<div class="c-pagination__pages">';
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
        if (i === currentPage) {
          html += `<span class="c-pagination__page__current">${i}</span>`;
        } else {
          html += `<button class="c-pagination__page__link" onclick="goToPage(${i})">${i}</button>`;
        }
      } else if (i === currentPage - 3 || i === currentPage + 3) {
        html += '<span class="c-pagination__page__hellip">...</span>';
      }
    }
    html += '</div>';
    
    // Next button
    if (currentPage < totalPages) {
      html += `<button class="c-pagination__nav c-pagination__nav--next" onclick="goToPage(${currentPage + 1})">Next</button>`;
    }
    
    html += '</div>';
    paginationContainer.innerHTML = html;
  }

  // Make goToPage available globally
  window.goToPage = function(page) {
    currentPage = page;
    performSearch();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  function getResultType(subtype, result) {
    // For events, determine type based on metadata
    if (subtype === 'tribe_events') {
      if (result && result.is_ondemand) {
        return 'Video';
      } else if (result && result.is_live) {
        return 'Live Event';
      } else if (result && result.is_past) {
        return 'Past Event';
      }
      return 'Event';
    }
    
    const typeMap = {
      'user': 'Member',
      'member': 'Member',
      'podcast': 'Podcast',
      'podcast': 'Podcast',
      'forum': 'Forum',
      'journal-entries': 'Journal Article',
      'journal_article': 'Journal Article',
      'post': 'News',
      'page': 'Page'
    };
    return typeMap[subtype] || 'Result';
  }

  function getTypeClass(type) {
    const classMap = {
      'Member': 'member',
      'Live Event': 'event',
      'Past Event': 'event',
      'Event': 'event',
      'Video': 'video',
      'Podcast': 'podcast',
      'Forum': 'forum',
      'Journal Article': 'journal',
      'News': 'post',
      'Page': 'event'
    };
    return classMap[type] || 'event';
  }

  function stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || '';
    return text.length > 150 ? text.substring(0, 150) + '...' : text;
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
})();
